<template>
  <div class="tab-content flex-direction is-active" id='mypage-comp-list-template'>
    <comp-app-form-btn @showAppForm="handleShowAppForm"></comp-app-form-btn>
    <div class="tab-container-sort">
      <div class="tab-menu-wrap scroll-tab">
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'ALL'}" @click="search('ALL')">전체</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'WAITING'}" @click="search('WAITING')">작성중</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'REFUSAL'}" @click="search('REFUSAL')">승인 반려</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'REQUEST'}" @click="search('REQUEST')">승인 요청</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'APPROVED'}" @click="search('APPROVED')">승인 완료</button>
        <button type="button" class="font-body-style3 tab-menu" :class="{'is-active' : searchMode === 'CLOSING'}" @click="search('CLOSING')">마감</button>
      </div>
    </div>
    <div class="tab-content sort-type">
      <div class="no-data" v-if="list.length === 0">
        <template v-if="searchMode === 'ALL'">등록된 공고가 없습니다</template>
        <template v-else>검색된 공고가 없습니다</template>
      </div>
      <div class="table-wrap no-line-mg scroll-table" v-else>
        <table class="table-list">
          <caption>공고목록</caption>
          <colgroup>
            <col style="width:80px">
            <col style="width:197px">
            <col style="width:96px">
            <col style="width:200px">
            <col style="width:80px">
            <col style="width:80px">
            <col style="width:120px">
            <col style="width:120px">
            <col style="width:96px">
            <col style="width:120px">
          </colgroup>
          <thead>
            <tr>
              <th scope="col">연번</th>
              <th scope="col">공고명</th>
              <th scope="col">경력</th>
              <th scope="col">업·직종</th>
              <th scope="col">모집인원</th>
              <th scope="col">신청인원</th>
              <th scope="col">신청자 목록</th>
              <th scope="col">마감일</th>
              <th scope="col">상태</th>
              <th scope="col">관리</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list" :key="index">
              <td class="text-c">{{ item.listNum }}</td>
              <td>{{ item.title }}</td>
              <td class="text-c">{{ item.careerHistory }}</td>
              <td class="text-c">{{ item.occupationCategory }}</td>
              <td class="text-c">{{ item.rcptPpl }}</td>
              <td class="text-c">{{ item.applyCnt }}</td>
              <td class="text-c">
                <button type="button" class="btn btn-gray btn-xsm" v-if="item.showRecannApp" @click="goAppRecannList(item.annNo)">상세보기</button>
              </td>
              <td class="text-c">{{ item.appdurngEd }}</td>
              <td class="text-c">{{ item.statusNm }}</td>
              <td class="text-c">
                <template v-if="item.status === 'WAITING'">
                  <button type="button" class="btn btn-primary btn-xsm" @click="showCompAppForm(item.annNo)">수정하기</button>
                  <button type="button" class="btn btn-gray btn-xsm" @click="recannDelete(item.annNo)">삭제하기</button>
                </template>
                <template v-else-if="item.status === 'REQUEST'">
                  <button type="button" class="btn btn-primary btn-xsm" @click="showCompAppForm(item.annNo)">수정하기</button>
                  <button type="button" class="btn btn-gray btn-xsm" @click="recannStatCancel(item.annNo)">요청 취소</button>
                </template>
                <template v-else-if="item.status === 'REFUSAL'">
                  <button type="button" class="btn btn-gray btn-xsm" @click="showRejectInfoModal(item)">반려사유</button>
                </template>
                <template v-else-if="item.status === 'APPROVED'">
                  <button type="button" class="btn btn-gray btn-xsm" @click="recannClose(item.annNo)">마감 처리</button>
                </template>
                <template v-else-if="item.isPossibleCancelClosing">
                  <button type="button" class="btn btn-gray btn-xsm" @click="recannCloseCancel(item.annNo)">마감 취소</button>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- 페이지네이션 -->
      <pagination :totalPages="paginationInfo.totalPageCount" :currentPage.sync="paginationInfo.currentPageNo" :size="paginationInfo.pageSize" @update:currentPage="handlePageChange"></pagination>
      <app-reject-info :title="seletedAnn.title" :rejectInfo="seletedAnn.REJECT_INFO" :appRejectInfoModal="appRejectInfoModal" @update:appRejectInfo="appRejectInfoModal = $event"></app-reject-info>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';
import CompAppFormBtn from '../components/CompAppFormBtn.vue';
import Pagination from '../../shared/Pagination.vue';
import AppRejectInfo from './AppRejectInfo.vue';

const statusMode = {
  ALL: { COMP_ANN_STAT: null, ANN_RCRT_STAT: null, name: '전체' },
  WAITING: { COMP_ANN_STAT: 'IN58001', ANN_RCRT_STAT: null, name: '작성중' }, // 작성중
  REFUSAL: { COMP_ANN_STAT: 'IN58004', ANN_RCRT_STAT: null, name: '승인 반려' }, // 승인 반려
  REQUEST: { COMP_ANN_STAT: 'IN58002', ANN_RCRT_STAT: null, name: '승인 요청' }, // 승인 요청
  APPROVED: { COMP_ANN_STAT: 'IN58003', ANN_RCRT_STAT: null, name: '승인 완료' }, // 승인 완료
  CLOSING: { COMP_ANN_STAT: null, ANN_RCRT_STAT: 'IN17004', name: '마감' }, // 마감
};

const careerHistoryCode = {
  ANY: '경력무관',
  NEW: '신입',
  EXPERIENCED: '경력',
};

const OccupationCategoryCode = {
  BUSINESS_FINANCE_ADMIN_INSURANCE: '경영/금융/사무/보험',
  PUBLIC_OFFICIAL_TEACHER: '공무원(교사)',
  EDUCATION_TUTOR_RESEARCH_LAW: '교육/강사/연구/법률',
  MEDICAL_HEALTH_WELFARE: '의료/보건/사회복지',
  MARKETING_TRADE: '마케팅/무역',
  PROFESSIONAL: '전문직(의사/변호사 등)',
  CULTURE_ART_MEDIA_DESIGN: '문화/예술/신문방송/디자인',
  SALES_CUSTOMER_SUPPORT: '영업/판매/고객상담/CS',
  CONSTRUCTION_ARCH_ENV_INDUSTRY: '건설/건축/환경/산업',
  IT_TELECOM_WEB: 'IT/정보통신/웹',
  HOSPITALITY_FOOD_TRAVEL_SECURITY: '숙박/음식/여행/스포츠/경비청소',
  ETC: '기타',
};

export default {
  name: 'mypage-comp-list-template',
  components: {
    CompAppFormBtn,
    Pagination,
    AppRejectInfo,
  },
  data() {
    return {
      paginationInfo: {},
      pagingParam: {
        pageIndex: 1, // 현재 페이지
      },
      searchMode: 'ALL',
      SRCH_COMP_ANN_STAT: null,
      SRCH_ANN_RCRT_STAT: null,
      pageIndex: 1,
      list: [],
      statusMode,
      careerHistoryCode,
      OccupationCategoryCode,
      seletedAnn: {},
      appRejectInfoModal: false,
    };
  },
  watch: {
    showApps: {
      handler(newVal) {
        if (newVal) this.getList();
      },
      immediate: true,
    },
    pageIndex: {
      handler() {
        this.getList();
      },
    },
  },
  methods: {
    search(mode) {
      this.searchMode = mode;
      this.SRCH_COMP_ANN_STAT = this.statusMode[mode].COMP_ANN_STAT;
      this.SRCH_ANN_RCRT_STAT = this.statusMode[mode].ANN_RCRT_STAT;
      this.pagingParam.pageIndex = 1;
      this.getList();
    },
    getList() {
      const params = {
        SRCH_COMP_ANN_STAT: this.SRCH_COMP_ANN_STAT,
        SRCH_ANN_RCRT_STAT: this.SRCH_ANN_RCRT_STAT,
        ...this.pagingParam,
      };
      Axios.get('/api/comp/in_appListAjax', { params })
        .then((response) => {
          if (response.data.success === 'R') {
            console.log(response.data);
            this.paginationInfo = response.data.paginationInfo;
            this.list = response.data.list.map((item) => {
              const annNo = item.ANN_NO;
              const status = this.findStatusCode(item.ANN_RCRT_STAT, item.COMP_ANN_STAT);
              const statusNm = this.statusMode[status].name;
              const listNum = (response.data.paginationInfo.totalRecordCount + 1) - item.RN;
              const showRecannApp = (status !== 'WAITING' && status !== 'REFUSAL');
              const isPossibleCancelClosing =
                (status === 'CLOSING' && item.APPDURNG_ED >= this.getTodayString());
              const newItem = {
                ...item,
                annNo,
                status,
                statusNm,
                listNum,
                title: item.ANN_NM,
                careerHistory: careerHistoryCode[item.CAREER_HISTORY],
                occupationCategory: item.OCCUPATION_LABEL || OccupationCategoryCode[item.OCCUPATION],
                rcptPpl: item.RCRT_PPL.toLocaleString('ko-KR'),
                applyCnt: item.APPLY_CNT.toLocaleString('ko-KR'),
                showRecannApp,
                appdurngEd: item.APPDURNG_ED,
                isPossibleCancelClosing,
              };
              return newItem;
            });
            console.log(this.list);
          }
        })
        .catch((e) => {
          console.log(e.data);
        });
    },
    findStatusCode(ANN_RCRT_STAT, COMP_ANN_STAT) {
      const keys = Object.keys(this.statusMode);
      const statusCode = (this.statusMode.CLOSING.ANN_RCRT_STAT === ANN_RCRT_STAT)
        ? 'CLOSING'
        : keys.find(key => this.statusMode[key].COMP_ANN_STAT === COMP_ANN_STAT);
      return statusCode;
    },
    getTodayString() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handlePageChange(newPage) {
      this.pagingParam.pageIndex = newPage;
      this.pageIndex = newPage;
      this.getList();
    },
    /**
     * 공고 등록 폼 표시 요청을 부모 컴포넌트로 전달
     */
    handleShowAppForm() {
      this.$emit('showAppForm');
    },
    /**
     * 신청자 현황 목록 표시 요청을 부모 컴포넌트로 전달
     * @param {number} annNo - 공고 번호
     */
    // handleShowAppRecannList(annNo) {
    //   this.$emit('showAppRecannList', annNo);
    // },
    goAppRecannList(annNo) {
      location.href = `/mypage-comp-app-recann.do?ANN_NO=${annNo}`;
    },
    showCompAppForm(annNo) {
      location.href = `/compAnnView.do?ANN_NO=${annNo}`;
    },
    showRejectInfoModal(item) {
      this.seletedAnn = item;
      this.appRejectInfoModal = true;
    },
    recannDelete(annNo) {
      if (confirm('해당 공고를 삭제하시겠습니까? 삭제 후에는 되돌릴 수 없습니다.')) {
        Axios.delete(`/api/comp/recannDelete?ANN_NO=${annNo}`).then((res) => {
          if (res.data.success === 'D') {
            alert('삭제되었습니다.');
            this.getList();
          }
        }).catch((e) => {
          console.log(e.data);
        });
      }
    },
    recannStatCancel(annNo) {
      if (confirm('해당 공고의 승인 요청을 취소하시겠습니까?')) {
        Axios.post(`/api/comp/recannStatCancel?ANN_NO=${annNo}`).then((res) => {
          if (res.data.success === 'U') {
            alert('취소되었습니다');
            this.getList();
          }
        }).catch((e) => {
          console.log(e.data);
        });
      }
    },
    recannClose(annNo) {
      if (confirm('해당 공고를 마감 상태로 변경하시겠습니까?')) {
        Axios.post(`/api/comp/recannClose?ANN_NO=${annNo}`).then((res) => {
          if (res.data.success === 'U') {
            alert('해당 공고가 마감되었습니다.');
            this.getList();
          }
        }).catch((e) => {
          console.log(e.data);
        });
      }
    },
    recannCloseCancel(annNo) {
      if (confirm('해당 공고의 마감 상태를 원복하시겠습니까?')) {
        Axios.post(`/api/comp/recannCloseCancel?ANN_NO=${annNo}`).then((res) => {
          if (res.data.success === 'U') {
            alert('승인 완료 상태로 원복되었습니다.');
            this.getList();
          }
        }).catch((e) => {
          console.log(e.data);
        });
      }
    }
  },
  mounted() {
    this.getList();
  },
};
</script>



// WEBPACK FOOTER //
// MypageCompAppList.vue?0a170fca